export const tr = {
    caption: '{format} {width}x{height} м',
    'caption-duration': '{duration} sn.',
    'caption-format': '{format} {width}×{height} m',
    'caption-resolution': '{width}×{height} px',
    format: '{format} ({width}×{height}, {duration} sn.)'
};
